import { gql } from '@apollo/client'
import { buildTags, MetaTags } from '@jusbrasil-web/docview/core'

import { ArticleNewsMetaTags_DocumentFragment } from './__generated__/article-news-meta-tags.graphql'
import { ArticleNewsSeoMetadata } from './article-news-seo-metadata'

export type ArticleNewsMetaTagsProps = {
  document: ArticleNewsMetaTags_DocumentFragment
}

export function ArticleNewsMetaTags(props: ArticleNewsMetaTagsProps) {
  const { document } = props
  const { url } = document
  const seoMetadata = new ArticleNewsSeoMetadata(document).getSeoMetadata()
  const tags = buildTags({ document, seoMetadata })

  return <MetaTags url={url} tags={tags} />
}

ArticleNewsMetaTags.fragments = {
  document: gql`
    fragment ArticleNewsMetaTags_document on Document {
      title
      artifact
      url
      meta
      noIndex
      text(highlight: true)
      subtitle
      description

      ...MetaTags_document
    }
    ${MetaTags.fragments.document}
  `,
}
